import { css } from 'styled-components';

export const ReactHintStyles = css`
  .react-hint {
    position: absolute;
    z-index: 999;
    margin-left: 12px;
    max-width: 400px;
    pointer-events: auto;
    animation: 0.2s fadeIn;
    cursor: default;

    &::after {
      position: absolute;
      top: calc(50% - 5px);
      left: -10px;
      width: 0;
      height: 0;
      content: '';
      border-top: 5px solid transparent;
      border-left: 5px solid transparent;
      border-right: 5px solid #fff;
      border-bottom: 5px solid transparent;
    }

    .react-hint__content {
      padding: 8px 15px;
      font-size: 14px;
      white-space: pre-line;
      background-color: #fff;
      border-radius: 6px;
      box-shadow: 0 2px 20px 0 rgba(191, 191, 172, 0.5);
    }
  }
`;
